import { api } from './client'
// import type { PaginatedResponse } from '@/types/api'

const API_URL = 'farm/yields-history/'

export default {
  async list() {
    const { data } = await api.get(API_URL)
    return data.results
  },
}
